import config from "../_config";

const DRIVE_FILES_URL = "https://www.googleapis.com/drive/v3/files";
const SLIDER_FILENAME_PATTERN = /^(\d+)\s*-\s*(.+)$/;

export const isGoogleDriveSliderConfigured = () =>
  Boolean(config.googleDrive.folderId && config.googleDrive.apiKey);

export const parseSliderFilename = (filename) => {
  const filenameWithoutExtension = filename.replace(/\.[^/.]+$/, "").trim();
  const match = filenameWithoutExtension.match(SLIDER_FILENAME_PATTERN);

  if (!match || !match[2].trim()) {
    return null;
  }

  return {
    order: Number(match[1]),
    caption: match[2].trim(),
  };
};

export const listGoogleDriveSliderImages = async () => {
  const { folderId, apiKey } = config.googleDrive;

  if (!isGoogleDriveSliderConfigured()) {
    throw new Error("Google Drive slider environment variables are missing.");
  }

  const query = new URLSearchParams({
    key: apiKey,
    q: `'${folderId}' in parents and trashed = false`,
    fields: "files(id,name,mimeType)",
    orderBy: "name_natural",
    pageSize: "1000",
    includeItemsFromAllDrives: "true",
    supportsAllDrives: "true",
  });
  const response = await fetch(`${DRIVE_FILES_URL}?${query.toString()}`);

  if (!response.ok) {
    let message = `Google Drive returned ${response.status}.`;

    try {
      const body = await response.json();
      message = body?.error?.message || message;
    } catch (error) {
      // Use the status-based message when Google does not return JSON.
    }

    throw new Error(message);
  }

  const { files = [] } = await response.json();

  return files
    .filter((file) => file.mimeType?.startsWith("image/"))
    .map((file) => {
      const parsedName = parseSliderFilename(file.name);

      if (!parsedName) {
        return null;
      }

      return {
        id: file.id,
        order: parsedName.order,
        originalAlt: parsedName.caption,
        original: `https://drive.google.com/thumbnail?id=${encodeURIComponent(file.id)}&sz=w1600`,
      };
    })
    .filter(Boolean)
    .sort(
      (a, b) =>
        a.order - b.order || a.originalAlt.localeCompare(b.originalAlt)
    );
};
